import { Metadata_Service } from './';
import { useQuery } from '@tanstack/react-query';
import { GetLatestConfigurationCheckRunResponse } from '../types/tecton_proto/metadataservice/metadata_service';
import { CheckResult, ResultStatus } from '../types/tecton_proto/configurationcheck/configurationcheck';

const statusSortPredicate = (a: CheckResult, b: CheckResult) => {
  const statusOrder = {
    [ResultStatus.RESULT_STATUS_FAILED]: 0,
    [ResultStatus.RESULT_STATUS_UNSPECIFIED]: 1,
    [ResultStatus.RESULT_STATUS_PASSED]: 2,
    // TODO: verify that this is the correct order
    [ResultStatus.RESULT_STATUS_UNKNOWN]: 3,
  };

  const aStatus = a.status ?? ResultStatus.RESULT_STATUS_UNSPECIFIED;
  const bStatus = b.status ?? ResultStatus.RESULT_STATUS_UNSPECIFIED;

  return statusOrder[aStatus] - statusOrder[bStatus];
};

const fetchUseGetDeployment = async (): Promise<GetLatestConfigurationCheckRunResponse> => {
  const { data } = await Metadata_Service('get-latest-configuration-check-run', {
    method: 'POST',
  });

  return data;
};

export const useGetDeployment = () => {
  return useQuery(['get-deployment'], () => fetchUseGetDeployment(), {
    select: (data) => {
      return {
        ...data,
        check_run: {
          ...data.check_run,
          check_results: data.check_run?.check_results?.sort(statusSortPredicate) ?? [],
        },
      };
    },
  });
};
